// CORE-8168: the options for the customer card's "Runsheet Template" selector. "Default" (no bound
// template, runSheetTemplateId null) always comes first, so the selector is never empty and never
// hides itself; the team's templates follow in the order the API returned them (by name).
export const DEFAULT_RUN_SHEET_TEMPLATE_OPTION = Object.freeze({ runSheetTemplateId: null, name: 'Default' });

export function buildRunSheetTemplateOptions(list) {
    return [DEFAULT_RUN_SHEET_TEMPLATE_OPTION, ...(list || [])];
}
